<section id="error-page">
  <h1 i18n>404 not found</h1>

</section>
